import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatCurrency, formatDate } from "../lib/api";
import PageHeader from "../components/PageHeader";
import { Search } from "lucide-react";

const Customers = () => {
    const [data, setData] = useState({ total: 0, items: [] });
    const [q, setQ] = useState("");
    const [loading, setLoading] = useState(true);

    const fetchAll = () => {
        setLoading(true);
        const params = new URLSearchParams();
        if (q) params.set("q", q);
        params.set("limit", 100);
        api.get(`/customers?${params.toString()}`)
            .then((r) => setData(r.data))
            .finally(() => setLoading(false));
    };
    useEffect(fetchAll, []);

    return (
        <div className="space-y-6">
            <PageHeader title="Customers" subtitle={`${data.total} total customers`} />

            <div className="bg-white border border-slate-200 rounded-2xl p-4 flex gap-3 items-center">
                <div className="relative flex-1">
                    <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                    <input
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && fetchAll()}
                        placeholder="Search by name, phone, email"
                        className="w-full pl-9 pr-3 py-2 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-mint-500/30"
                        data-testid="customers-search-input"
                    />
                </div>
                <button onClick={fetchAll} className="px-4 py-2 rounded-full bg-mint-500 text-white text-sm font-semibold hover:bg-mint-600" data-testid="customers-search-btn">Search</button>
            </div>

            <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-slate-50 border-b border-slate-200">
                            <tr className="text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
                                <th className="px-4 py-3">Name</th>
                                <th className="px-4 py-3">Phone</th>
                                <th className="px-4 py-3">Email</th>
                                <th className="px-4 py-3 text-right">Rides</th>
                                <th className="px-4 py-3 text-right">Total Spend</th>
                                <th className="px-4 py-3 text-right">Rating</th>
                                <th className="px-4 py-3">Joined</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                            {loading ? (
                                <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-400">Loading…</td></tr>
                            ) : data.items.map((c) => (
                                <tr key={c.id} className="hover:bg-slate-50" data-testid={`customer-row-${c.id}`}>
                                    <td className="px-4 py-3">
                                        <Link to={`/customers/${c.id}`} className="font-semibold text-navy-900 hover:text-mint-600">{c.name}</Link>
                                    </td>
                                    <td className="px-4 py-3 text-slate-600 tabular-nums">{c.phone}</td>
                                    <td className="px-4 py-3 text-slate-600 truncate max-w-[220px]">{c.email}</td>
                                    <td className="px-4 py-3 text-right tabular-nums">{c.total_rides || 0}</td>
                                    <td className="px-4 py-3 text-right font-semibold tabular-nums">{formatCurrency(c.total_spend || 0)}</td>
                                    <td className="px-4 py-3 text-right">{c.rating} ★</td>
                                    <td className="px-4 py-3 text-slate-500">{formatDate(c.created_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Customers;
